import { FC, useCallback, useMemo } from "react";
import { ListItemText, Stack } from "@mui/material";
import { BillingExplorerXAxisSelectorTrigger } from "./BillingExplorerXAxisSelectorTrigger";
import { billingExplorerXAxisOptions } from "./utils/constants";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { XAxisGranularity } from "@/services/cloudchipr.api";
import { setResourceExplorerAxisGranularity } from "@/store/resource-explorer/resourceExplorerSlice";
import { getResourceExplorerDataThunk } from "@/store/resource-explorer/thunks/widgets/getResourceExplorerDataThunk";
import { DropdownSelect } from "@/components/common/select/dropdown-select/DropdownSelect";
import { resourceExplorerAxisGranularitySelector } from "@/store/resource-explorer/selectors/current-resource-explorer/data/resourceExplorerAxisGranularitySelector";
import { setResourceExplorerGridDataViewTypeThunk } from "@/store/resource-explorer/thunks/resource-explorer/setResourceExplorerGridDataViewTypeThunk";
import { GroupingOptionIcon } from "@/components/pages/common/resource-explorer-grouping-selector/components/GroupingOptionIcon";

export const BillingExplorerXAxisSelector: FC = () => {
  const dispatch = useAppDispatch();

  const axisGranularity =
    useAppSelector(resourceExplorerAxisGranularitySelector) ?? "date";

  const renderOptions = useMemo(() => {
    return billingExplorerXAxisOptions.map((option) => {
      return {
        label: (
          <Stack direction="row" spacing={1} alignItems="center">
            <GroupingOptionIcon grouping={option.value} />
            <ListItemText primary={option.label} />
          </Stack>
        ),
        value: option.value,
        rawValue: {
          label: option.label,
        },
      };
    });
  }, []);

  const xAxisChangeHandler = useCallback(
    (selectedValues: string[]) => {
      if (axisGranularity === selectedValues[0]) {
        return;
      }

      dispatch(
        setResourceExplorerAxisGranularity(
          selectedValues[0] as XAxisGranularity,
        ),
      );
      dispatch(getResourceExplorerDataThunk());
      dispatch(setResourceExplorerGridDataViewTypeThunk("granular"));
    },
    [dispatch, axisGranularity],
  );

  return (
    <DropdownSelect
      values={[axisGranularity]}
      label="Granularity(X-Axis)"
      options={renderOptions}
      TriggerComponent={BillingExplorerXAxisSelectorTrigger}
      singleSelect
      submitHandlerOnClose={xAxisChangeHandler}
      sortSelectedOptions={false}
    />
  );
};
